module.exports = __webpack_public_path__ + "img/IMG_7234.27d85206.jpg";